export class ApiUrl {
  // baseUrl: string = "https://api-petrotrack.techraq.com"; // local api url
  baseUrl: string = "https://petrotrack-api.techraqdev.com"; //qa api url
  // baseUrl: string = "http://66.175.233.112:60606"; // live api url
  login: string = this.baseUrl + "/oauth2/token";
  logout: string = this.baseUrl + "/api/Admin/SignOut";
  GetMenuItems: string = this.baseUrl + "/api/Admin/GetMenuItems";
  ForgotPassword: string = this.baseUrl + "/api/Account/ForgotPassword?email=";
  //Dashboard
  GetSampleAlertsList = this.baseUrl + "/api/Dashboard/GetSampleAlertsList?customerId=";
  GetLabTatSampleStatus = this.baseUrl + "/api/Dashboard/GetLabTatSampleStatus";
  GetDashboardSampleReportCount = this.baseUrl + "/api/Dashboard/GetDashboardSampleReportCount";
  GetFailureCharacteristicsForDashboard = this.baseUrl + "/api/Dashboard/GetFailureCharacteristicsForDashboard";
  GetParameterCharacteristicsForDashboard = this.baseUrl + "/api/Dashboard/GetParamterCharacteristicsForDashboard";
  GetCriticalEquipmentsRequiringAction = this.baseUrl + "/api/Dashboard/GetCriticalEquipmentRequiringAction";
  GetDashboardMonthwiseSampleHealthTrend = this.baseUrl + "/api/Dashboard/GetDashboardMonthwiseSampleHealthTrend";
  GetJobCardSummary = this.baseUrl + "/api/Dashboard/GetJobCardSummary";
  GetOilGradePerformance = this.baseUrl + "/api/Dashboard/GetOilGradePerformance";
  DownloadDashboardPDF = this.baseUrl + "/api/Dashboard/DownloadDashboardExport";

  //GlobalRegistry
  addUnit = this.baseUrl + "/api/GlobalRegistry/UpsertUnit";
  GetUnits = this.baseUrl + "/api/GlobalRegistry/GetUnitList";
  GetUnitById = this.baseUrl + "/api/GlobalRegistry/GetUnitByUnitId?getUnitId=";
  DeleteUnit = this.baseUrl + "/api/GlobalRegistry/DeleteUnit?unitid=";
  GetCharectisticsList =
    this.baseUrl + "/api/GlobalRegistry/GetcharacteristicsList";
  AddCharectistics = this.baseUrl + "/api/GlobalRegistry/UpsertCharacteristic";
  DeleteCharesterstic =
    this.baseUrl + "/api/GlobalRegistry/DeleteCharesterstic?charestersticId=";
  GetCharacteristicsById =
    this.baseUrl +
    "/api/GlobalRegistry/GetCharacteristicsByCharecterId?characteristicsId=";
  GetUnitsForDDL = this.baseUrl + "/api/GlobalRegistry/GetUnitsMinInfoList";
  GetListofGraphTemplates =
    this.baseUrl + "/api/GlobalRegistry/GetListofGraphTemplates";
  UpsertGraphTemplates =
    this.baseUrl + "/api/GlobalRegistry/UpsertGraphTemplates";
  GetGraphTemplateById =
    this.baseUrl + "/api/GlobalRegistry/GetGraphTemplateById?templateId=";
  GetGraphConfigsByTemplateId =
    this.baseUrl +
    "/api/GlobalRegistry/GetGraphConfigsByTemplateId?templateId=";
  UpsertGraphConfig = this.baseUrl + "/api/GlobalRegistry/UpsertGraphConfig";
  GetListOfGraphTypes =
    this.baseUrl + "/api/GlobalRegistry/GetListOfGraphTypes";
  DeleteGraphTemplateById =
    this.baseUrl + "/api/GlobalRegistry/DeleteGraphTemplateById?templateId=";
  GetSampPointsList = this.baseUrl + "/api/GlobalRegistry/GetSampPointsList";
  UpsertSampPoint = this.baseUrl + "/api/GlobalRegistry/UpsertSamplingPoint";
  GetSampPointById =
    this.baseUrl + "/api/GlobalRegistry/GetSampPointById?sampPointId=";
  DeleteSampPoint =
    this.baseUrl + "/api/GlobalRegistry/DeleteSamplingPoint?sampPointId=";
  GetEquipmentList = this.baseUrl + "/api/GlobalRegistry/GetEquipmentList";
  UpsertEquipment = this.baseUrl + "/api/GlobalRegistry/UpsertEquipment";
  GetEquipmentById =
    this.baseUrl + "/api/GlobalRegistry/GetEquipmentById?equipmentId=";
  DeleteEquipment =
    this.baseUrl + "/api/GlobalRegistry/DeleteEquipment?equipmentId=";
  GetSpIdList = this.baseUrl + "/api/GlobalRegistry/GetSpIdList";
  UpsertSpId = this.baseUrl + "/api/GlobalRegistry/UpsertSpId";
  GetSpIdById = this.baseUrl + "/api/GlobalRegistry/GetSpIdById?spId=";
  DeleteSpId = this.baseUrl + "/api/GlobalRegistry/DeleteSpId?spId=";
  GetMaxSPIDValue = this.baseUrl + "/api/GlobalRegistry/GetMaxSPIDValue";
  GetSpIdChars = this.baseUrl + "/api/Analysis/GetSpIdChars?spId=";
  GetSpIdCharsList = this.baseUrl + "/api/Analysis/GetSpIdCharsList?spId=";
  GetListOfSpIdChars =
    this.baseUrl + "/api/GlobalRegistry/GetListOfSpIdChars?spId=";
  UpsertSpIdChars = this.baseUrl + "/api/GlobalRegistry/UpsertSpIdChars";
  GetSampPointsMinInfoList =
    this.baseUrl + "/api/GlobalRegistry/GetSampPointsMinInfoList";
  GetEquipmentMinInfoList =
    this.baseUrl + "/api/GlobalRegistry/GetEquipmentMinInfoList";
  UpsertComponent = this.baseUrl + "/api/GlobalRegistry/UpsertComponent";
  GetComponentList = this.baseUrl + "/api/GlobalRegistry/GetComponentList";
  DeleteComponent =
    this.baseUrl + "/api/GlobalRegistry/DeleteComponent?componentId=";
  GetComponentById =
    this.baseUrl + "/api/GlobalRegistry/GetComponentById?componentId=";
  GetComponentMinInfoList =
    this.baseUrl + "/api/GlobalRegistry/GetComponentMinInfoList";
  UpsertCollectionEngineer =
    this.baseUrl + "/api/GlobalRegistry/UpsertCollectionEngineer";
  GetCollectionEngineerList =
    this.baseUrl + "/api/GlobalRegistry/GetCollectionEngineerList";
  DeleteCollectionEngineer =
    this.baseUrl +
    "/api/GlobalRegistry/DeleteCollectionEngineer?collectionEngrId=";
  GetCollectionEngineerById =
    this.baseUrl +
    "/api/GlobalRegistry/GetCollectionEngineerById?collectionEngrId=";
  GetCollectionEngineerMinInfoList =
    this.baseUrl + "/api/GlobalRegistry/GetCollectionEngineerMinInfoList";
  UpsertArea = this.baseUrl + "/api/GlobalRegistry/UpsertArea";
  GetAreaList = this.baseUrl + "/api/GlobalRegistry/GetAreaList";
  GetAreaByAreaId =
    this.baseUrl + "/api/GlobalRegistry/GetAreaByAreaId?getAreaId=";
  DeleteArea = this.baseUrl + "/api/GlobalRegistry/DeleteArea?areaId=";
  GetAreaMinInfoList = this.baseUrl + "/api/GlobalRegistry/GetAreasMinInfoList";
  GetLubricantTypesList =
    this.baseUrl + "/api/GlobalRegistry/GetLubricantTypesList";
  GetListOfLubricantChars =
    this.baseUrl +
    "/api/GlobalRegistry/GetListOfLubricantChars?lubricantTypeId=";
  GetListOfLubricantCharsForDDr =
    this.baseUrl +
    "/api/GlobalRegistry/GetListOfLubricantCharsForDDr?lubricantTypeId=";
  UpsertLubricantChars =
    this.baseUrl + "/api/GlobalRegistry/UpsertLubricantChars";
  GetLubricantTypeDetails =
    this.baseUrl + "/api/GlobalRegistry/GetLubricantTypeDetails?lubTypeId=";
  DeleteLubricantType =
    this.baseUrl + "/api/GlobalRegistry/DeleteLubricantType?lubTypeId=";
  UpsertLubricantTypes =
    this.baseUrl + "/api/GlobalRegistry/UpsertLubricantTypes";
  UpsertShip = this.baseUrl + "/api/GlobalRegistry/UpsertShip";
  GetShipList = this.baseUrl + "/api/GlobalRegistry/GetShipList";
  DeleteShip = this.baseUrl + "/api/GlobalRegistry/DeleteShip?shipId=";
  GetShipById = this.baseUrl + "/api/GlobalRegistry/GetShipById?id=";
  GetShipMinInfoList = this.baseUrl + "/api/GlobalRegistry/GetShipMinInfoList";
  UpsertRecommendation =
    this.baseUrl + "/api/GlobalRegistry/UpsertRecommendation";
  GetRecommendationsList =
    this.baseUrl + "/api/GlobalRegistry/GetRecommendationsList";
  DeleteRecommendation =
    this.baseUrl + "/api/GlobalRegistry/DeleteRecommendation?recId=";
  GetRecommendationById =
    this.baseUrl + "/api/GlobalRegistry/GetRecommendationById?recId=";
  GetRecommendationsMinInfoList =
    this.baseUrl +
    "/api/GlobalRegistry/GetRecommendationsMinInfoList?sampleTypeId=";
  ExportEquipmentExcel =
    this.baseUrl + "/api/GlobalRegistry/EquipmentExportExcel";

  //Analysis
  AddUpdateJobCard = this.baseUrl + "/api/Analysis/UpsertJobCards";
  GetListOfJobCard = this.baseUrl + "/api/Analysis/GetListOfJobCard";
  DeleteJobCardById =
    this.baseUrl + "/api/Analysis/DeleteJobCardById?jobCardId=";
  GetJobCardByJobCardId =
    this.baseUrl + "/api/Analysis/GetJobCardByJobCardId?jobCardId=";

  GetListOfJobCardChars =
    this.baseUrl + "/api/Analysis/GetListOfJobCardChars?jobCardId=";
  UpsertJobCardChars = this.baseUrl + "/api/Analysis/UpsertJobCardChars";
  GetMaxJobCardValue = this.baseUrl + "/api/Analysis/GetMaxJobCardValue";
  GetMinSampleReceivedTypesList =
    this.baseUrl + "/api/Analysis/GetMinSampleReceivedTypesList";
  GetMinInfoSampleTypes = this.baseUrl + "/api/Analysis/GetMinInfoSampleTypes";
  GetEquipmentsFromJobCard =
    this.baseUrl + "/api/Analysis/GetEquipmentsFromJobCard?jobCardId=";
  PopulateValuesBasedOnSpidId =
    this.baseUrl +
    "/api/Analysis/PopulateValuesBasedOnSpidId?spidId=";
  GetPurchaseOrderFromCustomer =
    this.baseUrl + "/api/Analysis/GetPurchaseOrderFromCustomer?customerId=";
  GetJobCardNoFromCustomer =
    this.baseUrl + "/api/Analysis/GetJobCardNoFromCustomer?customerId=";
  GetJobCardsByCustomer =
    this.baseUrl + "/api/Analysis/GetJobCardsByCustomer?customerId=";
  GetCharsBasedonJobCard =
    this.baseUrl + "/api/Analysis/GetCharsBasedonJobCard?jobCardId=";
  GetEquipmentsBasedOnShip =
    this.baseUrl + "/api/Analysis/GetEquipmentsBasedOnShip?shipId=";

  AddUpdateSample = this.baseUrl + "/api/Analysis/UpsertSample";
  GetJobcradsForDDL = this.baseUrl + "/api/Analysis/GetMinJobCardList";
  GetEquipmentCategoryForDDL =
    this.baseUrl + "/api/Analysis/GetEquipmentCategoryList";
  GetCharacteristics =
    this.baseUrl + "/api/GlobalRegistry/GetCharacteristicsMinInfoList";
  GetOilGradesForDDL =
    this.baseUrl + "/api/ReportConfig/GetOilGradeMinInfoList";
  GetSampleStatusForDDL = this.baseUrl + "/api/Analysis/GetSampleStatusList";
  GetSamplesList = this.baseUrl + "/api/Analysis/GetListOfSamples";
  GetSampleById = this.baseUrl + "/api/Analysis/GetSampleBySampleId?sampleId=";
  GetSampleDetail = this.baseUrl + "/api/Analysis/GetSampleDetails?sampleId=";
  DeleteSample =
    this.baseUrl + "/api/Analysis/DeleteSampleBySampleId?sampleId=";
  AddSampleReport = this.baseUrl + "/api/Analysis/UpsertSampleReport";
  GetSampleReportById =
    this.baseUrl + "/api/Analysis/GetSampleReportBySampleId?sampleId=";
  GetListOfSectionChars =
    this.baseUrl + "/api/Analysis/GetListOfSectionChars?sampleId=";
  UpsertSampleResultChars =
    this.baseUrl + "/api/Analysis/UpsertSampleResultChars";
  GetListOfSectionCharsForFerrography =
    this.baseUrl +
    "/api/Analysis/GetListOfSectionCharsForFerrography?sampleId=";
  GetFerroGraphyResultsBySampleId =
    this.baseUrl + "/api/Analysis/GetFerroGraphyResultsBySampleId?sampleId=";
  UpsertFerroGraphyResultsDetails =
    this.baseUrl + "/api/Analysis/UpsertFerroGraphyResultsDetails";
  GetFerrographyImagesbySampleId =
    this.baseUrl + "/api/Analysis/GetFerrographyImagesbySampleId?sampleId=";
  DeleteFerrographyImage =
    this.baseUrl + "/api/Analysis/DeleteFerrographyImage?imageId=";
  GetMinInfoFerroGraphyResultTypes =
    this.baseUrl + "/api/Analysis/GetMinInfoFerroGraphyResultTypes";
  UpsertSampleResults = this.baseUrl + "/api/Analysis/UpsertSampleResults";
  GetSampleResultsDetailsBySampleId =
    this.baseUrl + "/api/Analysis/GetSampleResultsDetailsBySampleId?sampleId=";
  ViewSampleReport = this.baseUrl + "/api/Analysis/ViewSampleReport?sampleId=";
  UploadFile = this.baseUrl + "/api/Analysis/UploadFile";
  UploadFileOld = this.baseUrl + "/api/Analysis/UploadFileOld";
  SaveFerrographyImages = this.baseUrl + "/api/Analysis/SaveFerrographyImages";
  GetListOfMinTestMethods =
    this.baseUrl + "/api/ReportConfig/GetListOfMinTestMethods";
  GetListOfTestRatings =
    this.baseUrl + "/api/ReportConfig/GetListOfTestRatings";
  GetPublishedResults = this.baseUrl + "/api/Analysis/GetPublishedSamples";
  GetGraphTempleteTypeList =
    this.baseUrl + "/api/Analysis/GetGraphTempleteTypeList";
  GetSampleWorkFlowActions =
    this.baseUrl + "/api/Analysis/GetSampleWorkFlowActions?sampleId=";
  MarkSampleInProgress =
    this.baseUrl + "/api/Analysis/MarkSampleInProgress?sampleId=";
  DownLoadSampleReport =
    this.baseUrl + "/api/Analysis/DownLoadSampleReport?sampleId=";
  GenerateReport = this.baseUrl + "/api/Analysis/GenerateReport?sampleId=";
  RevertToApproved = this.baseUrl + "/api/Analysis/RevertToApproved?sampleId=";
  GetSampleStatusBySampleId =
    this.baseUrl + "/api/Analysis/GetSampleStatusBySampleId?sampleId=";
  PopulateSpIdValues =
    this.baseUrl + "/api/Analysis/PopulateSpIdValues?jobCardId=";
  PopulateSpIdValuesByCustomerId =
    this.baseUrl + "/api/Analysis/PopulateSpIdValuesByCustomerId?CustId=";
  PopulateSamplePtandEquipment =
    this.baseUrl + "/api/Analysis/PopulateSamplePtandEquipment?spId=";
  GetMinSamplingPntsInfo =
    this.baseUrl + "/api/Analysis/GetMinSamplingPntsInfo";
  GetMinEquipmentInfo = this.baseUrl + "/api/Analysis/GetMinEquipmentInfo";
  GetReportTemplatesMinInfoList =
    this.baseUrl + "/api/Analysis/GetReportTemplatesMinInfoList";
  DownloadNablExcel =
    this.baseUrl + "/api/Analysis/DownloadNablExcel?sampleId=";
     DownloadOilAnalysisExcel =
    this.baseUrl + "/api/Analysis/DownloadExcelFile?fileName=";
  GetLubricantsMinInfoList =
    this.baseUrl + "/api/Analysis/GetLubricantsMinInfoList";
  UpsertFerroGraphyRecommendationsandRatings =
    this.baseUrl + "/api/Analysis/UpsertFerroGraphyRecommendationsandRatings";
  GetFerroRecommendations =
    this.baseUrl + "/api/Analysis/GetFerroRecommendations?sampleId=";
  ImportSampleReport = this.baseUrl + "/api/Analysis/ImportSampleReportNew";
  DownloadJobCardRelatedReports =
    this.baseUrl + "/api/Analysis/DownloadJobCardRelatedReports?jobCardId=";
  GetCustomerMailFromJobCardId =
    this.baseUrl + "/api/Analysis/GetCustomerMailFromJobCardId?jobCardId=";
  SendReportAsMailToCustomer =
    this.baseUrl + "/api/Analysis/SendReportAsMailToCustomer";
  SaveImportedSampleReport =
    this.baseUrl + "/api/Analysis/SaveImportedSampleReport";
  SaveMailAttachedReport =
    this.baseUrl + "/api/Analysis/SaveMailAttachedReport";
  GetAutoTestRatingForLubChar =
    this.baseUrl + "/api/Analysis/GetAutoTestRatingForLubChar";
  DownloadSampleDetails = this.baseUrl + "/api/Analysis/DownloadSampleDetails/";

  GetDeletedSamplesOrJobCards =
    this.baseUrl + "/api/Analysis/GetDeletedSamplesOrJobCards";
  ActivateSampleOrJobCard =
    this.baseUrl + "/api/Analysis/ActivateSampleOrJobCard?screenTypeId=";
  GetTestRatingId =
    this.baseUrl + "/api/ReportConfig/GetOverAllRatingId?sampleId=";
  CalculateViscosityIndex =
    this.baseUrl + "/api/Analysis/CalculateViscosityIndex";

  //User
  GetUserTypes = this.baseUrl + "/api/Admin/GetUserTypes";
  GetLabsMinInfoList = this.baseUrl + "/api/Admin/GetLabsMinInfoList";
  GetRoles = this.baseUrl + "/api/Admin/GetRoles?userTypeId=";
  GetCustomersMinInfoList = this.baseUrl + "/api/Admin/GetCustomersMinInfoList";
  AddUser = this.baseUrl + "/api/Admin/UpsertUser";
  GetUserList = this.baseUrl + "/api/Admin/GetUserList";
  DeleteUser = this.baseUrl + "/api/Admin/DeleteUser?userId=";
  GetUserByUserId = this.baseUrl + "/api/Admin/GetUserByUserId?userId=";
  UpdatePassword = this.baseUrl + "/api/Admin/UpdatePassword";

  //Adminstration
  GetCountries = this.baseUrl + "/api/GlobalRegistry/GetCountriesMinInfoList";
  GetStates = this.baseUrl + "/api/Admin/GetStatesMinInfoList?countryId=";
  GetCustLabs = this.baseUrl + "/api/Admin/GetLabsMinInfoList";
  AddCustomer = this.baseUrl + "/api/Admin/UpsertCustomer";
  UploadCustomerLogo = this.baseUrl + "/api/Admin/UploadCustomerLogo";
  DeleteCustomerLogo =
    this.baseUrl + "/api/Admin/DeleteCustomerLogo?customerId=";
  GetCustomersList = this.baseUrl + "/api/Admin/GetCustomersList";
  GetListOfCustomerChars =
    this.baseUrl + "/api/Admin/GetListOfCustomerChars?customerId=";
  UpsertCustomerChars = this.baseUrl + "/api/Admin/UpsertCustomerChars";
  DeleteCustomer = this.baseUrl + "/api/Admin/DeleteCustomer?custId=";
  GetCustomerById = this.baseUrl + "/api/Admin/GetCustomerById?custId=";
  UpsertUserProfileSettings =
    this.baseUrl + "/api/Admin/UpsertUserProfileSettings";
  GetUserProfile = this.baseUrl + "/api/Admin/GetUserProfile";
  GetRolePriv = this.baseUrl + "/api/Admin/GetPrivilegeBasedOnNavUrl?navUrl=";
  GetUsersBasedOnRole = this.baseUrl + "/api/Admin/GetUsersBasedOnRole?roleId=";
  AddLab = this.baseUrl + "/api/Admin/UpsertLab";
  DeleteLab = this.baseUrl + "/api/Admin/DeleteLab?labId=";
  GetLabList = this.baseUrl + "/api/Admin/GetLabList";
  GetLabById = this.baseUrl + "/api/Admin/GetLabByLabId?labId=";
  GetLabDetails = this.baseUrl + "/api/Admin/GetLabDetails?labId=";

  GetRolesList = this.baseUrl + "/api/Admin/GetRolesList";
  GetListOfAppPrivileges =
    this.baseUrl + "/api/Admin/GetListOfAppPrivileges?roleId=";
  UpsertAppPrivileges = this.baseUrl + "/api/Admin/UpsertAppPrivileges";

  //Report Config
  AddEditPrdGrd = this.baseUrl + "/api/ReportConfig/UpsertPrdGrd";
  DeletePrdGrd = this.baseUrl + "/api/ReportConfig/DeletePrdGrd?grdId=";
  GetPrdGrdById =
    this.baseUrl + "/api/ReportConfig/GetOilGradeById?oilGradeId=";
  GetPrdGrdList = this.baseUrl + "/api/ReportConfig/GetListOfOilGrades";
  GetCharValueTypes = this.baseUrl + "/api/ReportConfig/GetCharValueTypes";
  GetCharSpecComparisionTypes =
    this.baseUrl + "/api/ReportConfig/GetCharSpecComparisionTypes";

  AddEditTestMethod = this.baseUrl + "/api/ReportConfig/UpsertTestMethods";
  DeleteTestMethod =
    this.baseUrl + "/api/ReportConfig/DeleteTestMethod?tstMthdId=";
  GetTestMethodDetails =
    this.baseUrl + "/api/ReportConfig/GetTestMthdByMthdId?tstMthdId=";
  GetTestMethodList = this.baseUrl + "/api/ReportConfig/GetTestMethodList";

  GetAnalysisSectionsList =
    this.baseUrl + "/api/ReportConfig/GetAnalysisSectionsList";
  UpsertSectionName = this.baseUrl + "/api/ReportConfig/UpsertSectionName";
  DeleteSectionName =
    this.baseUrl + "/api/ReportConfig/DeleteSectionName?sectionId=";
  GetAnalysisSectionElementsList =
    this.baseUrl +
    "/api/ReportConfig/GetAnalysisSectionElementsList?sectionId=";
  SortArrayByAscending =
    this.baseUrl + "/api/ReportConfig/SortArrayByAscending";

  //Reports
  GetSampleStatisticsList = this.baseUrl + "/api/Reports/GetSampleStatistics";
  ExportSampStatExcel = this.baseUrl + "/api/Reports/StatisticsExportExcel";
  OilAnalysisExportExcel = this.baseUrl + "/api/Analysis/ExportOilAnalysisReport";
  GetSampleTurnAroundTimeList =
    this.baseUrl + "/api/Reports/GetListOfSampleTurnAroundTime";
  ExportSTTExcel = this.baseUrl + "/api/Reports/STTExportExcel";
  ConsolidatedList = this.baseUrl + "/api/Reports/GetListOfConsolidatedReport";
  ExportConsolidatedExcel =
    this.baseUrl + "/api/Reports/ConsolidatedExportExcel";
  DownLoadConsolidatedReport =
    this.baseUrl + "/api/Reports/DownLoadConsolidatedReport";
  //user ZenMoney
  getUserRoles = this.baseUrl + "/api/Account/GetUserRoles";
  AddEditUser = this.baseUrl + "/api/Account/Register";
  UpdateUser = this.baseUrl + "/api/Account/UpdateUser";
  EditUserById = this.baseUrl + "/api/Account/EditUserById?id=";
  UsersList = this.baseUrl + "/api/Account/UsersList";
  DeleteUserById = this.baseUrl + "/api/Account/DeleteUserById?id=";
  ChangePassword = this.baseUrl + "/api/Account/ChangePassword";

  //Client related
  GetClientTypes: string = this.baseUrl + "/api/Client/GetClientTypes";
  GetAccountHoldertypes: string =
    this.baseUrl + "/api/Client/GetAccountHoldertypes?clintTypeId=";
  GetAccountHoldingtypes: string =
    this.baseUrl + "/api/Client/GetAccountHoldingtypes";
  GetClientsList: string = this.baseUrl + "/api/Client/GetClientsList";
  EditClientById: string = this.baseUrl + "/api/Client/EditClientById?id=";
  DeleteClientById: string = this.baseUrl + "/api/Client/DeleteClientById?id=";
  ClientRegister: string = this.baseUrl + "/api/Account/ClientRegister";
  GetClientUrlById: string = this.baseUrl + "/api/Client/GetClientUrlById?id=";
  UpdateClientByCustomer: string =
    this.baseUrl + "/api/Client/UpdateClientByCustomer?id=";
  DownLoadPdfForm: string =
    this.baseUrl + "/api/GeneratePdf/DownLoadPdfForm?clientId=";
  GetFormFillingPercentage: string =
    this.baseUrl + "/api/Client/GetFormFillingPercentage?clientId=";
  UpdateFormFillingPercentage: string =
    this.baseUrl + "/api/Client/UpdateFormFillingPercentage";
  AddUpdateComments: string = this.baseUrl + "/api/Client/AddUpdateComments";
  GetComments: string = this.baseUrl + "/api/Client/GetComments?clientId=";

  //GetComments
  GetStatesList: string = this.baseUrl + "/api/Client/GetStatesList";
  AddUpdateStates: string = this.baseUrl + "/api/Client/AddUpdateStates";
  EditStateById: string = this.baseUrl + "/api/Client/EditStateById?id=";
  DeleteStateById: string = this.baseUrl + "/api/Client/DeleteStateById?id=";

  //UpdateFormFillingPercentage

  //Clint from external
  GetClientsByUniqueRandomId: string =
    this.baseUrl + "/api/Client/GetClientsByUniqueRandomId?id=";
  //GetCountries: string = this.baseUrl + '/api/Individual/GetCountries';
  // GetStates: string = this.baseUrl + '/api/Individual/GetStates?countryId=';
  GetTitles: string = this.baseUrl + "/api/Individual/GetTitles";
  GetAddressProofTypes: string =
    this.baseUrl + "/api/Individual/GetAddressProofTypes";
  GetAnnualIncomes: string = this.baseUrl + "/api/Individual/GetAnnualIncomes";
  GetSettlementOfFunds: string =
    this.baseUrl + "/api/Individual/GetSettlementOfFunds";
  //Nominee
  AddUpdateNominee: string = this.baseUrl + "/api/Individual/AddUpdateNominee";
  EditNomineeById: string =
    this.baseUrl + "/api/Individual/EditNomineeById?id=";
  GetNomineesList: string =
    this.baseUrl + "/api/Individual/GetNomineesList?clientId=";
  DeleteNominee: string =
    this.baseUrl + "/api/Individual/DeleteNominee?nomineeId=";

  //NonIndiviualTrading
  AddNonIndividualTrading: string =
    this.baseUrl + "/api/NonIndividual/AddUpdateNonIndividualTrading";
  EditNonIndividualTrading: string =
    this.baseUrl + "/api/NonIndividual/EditNonIndividualTradingById?id=";

  // AddPromoters
  GetPoliticallyExposedTypes: string =
    this.baseUrl + "/api/Individual/GetPoliticallyExposedTypes";
  AddPromoters: string = this.baseUrl + "/api/NonIndividual/AddUpdatePromoters";
  GetPromoterDetailsById: string =
    this.baseUrl + "/api/NonIndividual/EditPromoterDetailsById?id=";
  GetPromotersList: string =
    this.baseUrl + "/api/NonIndividual/GetPromotersList";
  DeletePromoterById: string =
    this.baseUrl + "/api/NonIndividual/DeletePromoterById?id=";

  //Non Ind cus
  AddUpdateNonIndividualCustomer: string =
    this.baseUrl + "/api/NonIndividual/AddUpdateNonIndividualCustomer";
  EditNonIndividualById: string =
    this.baseUrl + "/api/NonIndividual/EditNonIndividualById?id=";
  GetNonIndvCustomerTypes: string =
    this.baseUrl + "/api/NonIndividual/GetNonIndvCustomerTypes";
  GetBankAccountTypes: string =
    this.baseUrl + "/api/NonIndividual/GetBankAccountTypes";

  //Account Holders
  GetClientsCustomersList: string =
    this.baseUrl + "/api/Client/GetClientsCustomersList?clientId=";
  AddUpdateClientCustomers: string =
    this.baseUrl + "/api/Client/AddUpdateClientCustomers";
  DeleteClientCustomer: string =
    this.baseUrl + "/api/Client/DeleteClientCustomer?id=";
  GetClientCustomerDetailsById: string =
    this.baseUrl + "/api/Client/GetClientCustomerDetailsById?id=";
  GetClientAndCustomerUniqueRandomId: string =
    this.baseUrl + "/api/Client/GetClientAndCustomerUniqueRandomId?uniqueId=";
  MakeCustomerEdit: string = this.baseUrl + "/api/Individual/MakeCustomerEdit";

  AddIndividualTrading: string =
    this.baseUrl + "/api/Individual/AddUpdateIndividualTrading";
  EditIndividualTrading: string =
    this.baseUrl + "/api/Individual/EditIndividualTradingById?id=";
  GetAccountTypes: string = this.baseUrl + "/api/Individual/GetAccountTypes";
  GetIntroducerStatusTypes: string =
    this.baseUrl + "/api/Individual/GetIntroducerStatusTypes";

  AddUpdateNomineeIdentityProofDetails: string =
    this.baseUrl + "/api/Individual/AddUpdateNomineeProofDetails";
  EditUpdateNomineeIdentityProofDetails: string =
    this.baseUrl + "api/Individual/EditNomieeIdentityProofsById?id=";
  UpdateKYCFormFillingPercentage: string =
    this.baseUrl + "/api/KYC/UpdateFormFillingPercentage";

  //media files
  GetDigitalSignaturesList = this.baseUrl + "/api/Admin/GetDigitalSignatures";
  upsertSignature = this.baseUrl + "/api/Admin/UpsertDigitalSignature";
  GetMediaFileById = this.baseUrl + "/api/Admin/GetMediaFileById/";
  DeleteMediaFile = this.baseUrl + "/api/Admin/DeleteDigitalSignature/";
  GetMediaFiles = this.baseUrl + "/api/Admin/GetMediaFiles";
  
  GetFileCategorys = this.baseUrl + "/api/Admin/GetFileCategorys";

  GetNablLogo = this.baseUrl + "/api/Admin/GetNablLogo";
  GetSubmittedSamplesList = this.baseUrl + '/api/Analysis/GetSubmittedSamplesList';
  UpdateLeadStatus =this.baseUrl + '/api/Analysis/UpdateLeadStatus';
  GetLeadStatusType = this.baseUrl + '/api/Analysis/GetLeadStatusType';
}

//
